
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.05 17.8a2.08 2.08 0 00.95.2 2 2 0 001.3-.46l5.1-4.21A1.72 1.72 0 0018 12a1.7 1.7 0 00-.64-1.32l-5.1-4.22a2.1 2.1 0 00-2.21-.26A1.77 1.77 0 009 7.79v8.42a1.76 1.76 0 001.05 1.59z"}})])
          )
        }
      }
    